import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {AlgChannelService} from "./channel.service";
import { Core2Config } from '../../../shared';

@Injectable({providedIn: "root"})
export class ShopeeService extends AlgChannelService {

  constructor(httpClient: HttpClient) {
    super();
    this.apiUrl = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ALG_CC_MODULE + "shopee-api/send";
    this.httpClient = httpClient;
  }


  public createVoucher(data: any, apiVisa: any) {
    let apiPath = apiVisa.api_domain_url +Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ALG_CC_MODULE + "shopee-api/create-voucher";
    return this.httpClient.post(apiPath, data, this.getHttpHeader(apiVisa));
  }


  public synVoucher(apiVisa: any, endpoint_id:string) {
    let apiPath = apiVisa.api_domain_url +Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ALG_CC_MODULE + "shopee-api/sync-vouchers" + endpoint_id;
    return this.httpClient.get(apiPath, this.getHttpHeader(apiVisa));
  }

}
